// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.couponDiv {
  border-radius: 10px;
  display: flex;
  align-items: center !important;
  text-align: center !important;
  font-size: 0.9rem;
  padding: 5px !important;
  background-color: white;
  border-style: outset;
  padding: 0.5rem 0;
}

.dark .couponDiv {
  background-color: #2b2f42 !important;
  color: #fff !important;
}

.coupon-container {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

/* .button-class {
  font-weight: bold;
  float: right;
  height: 2rem;
  background-color: "#5271FF";
  border-radius: 15px !important;
} */

.button-class {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: none !important;
}

.button-class:focus {
  outline: none;
  background-color: #cddef9;
  border: 1px solid #0562fb;
}

.button-class:hover {
  background-color: "#1f47ff";
}

.button-selected {
  color: red !important;
}

/* CSS */
.button-class {
  font-weight: bold;
  color: #0562fb;
  cursor: pointer;
}

.applied-text {
  color: #0562fb !important;
}

.button-class:hover {
  opacity: 1;
  transform: scale(1.2);
  transition: all 0.1s ease-in-out 0.1s;
}

.particularCategoryEachItemImg {
  width: 60%;
  display: flex;
  justify-content: center !important;
  margin: auto !important;
  height: 13vh !important;
  border-radius: 10px !important;
  margin-top: 1vh !important;
}

.drawerCloseIcon {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
}

.drawerCloseIcon ::selection {
  color: #7ed957;
}

.closePopCrossIcon {
  color: white !important;
}

.popUpVerifyBtn {
  margin-left: 8%;
  font-size: medium;

  border: none !important;
  color: #7ed957;
  cursor: pointer;
}

.popUpVerifyBtn1 {
  margin-left: 8%;
  font-size: medium;
  color: white;
  cursor: pointer;
}

.skipBtnContainer {
  display: flex !important;
  width: 100% !important;
}

.skipNowbtn {
  cursor: pointer !important;
}

.coupons-container {
  /* background-color: #f7f7ff; */
  background-color: #F5F5F5;
  padding: 1rem;
  z-index: 1201;
}

@media (max-width: 576px) {
  .coupons-container {
    padding: 0.5rem;
    z-index: 0;
    margin-top: 3.2rem;
  }
}

.dark .coupons-container {
  background-color: #2b2f42;
}

.leftContainer {
  padding-right: 5px;
  width: 100% !important;
}

@media (max-width: 576px) {
  .leftContainer {
    padding: 0;
  }
}

.addCustomericonsDiv {
  display: flex;
  align-content: center;
  color: white;
}

.subContainer {
  width: 100%;
}

.inputText {
  width: 100%;
  border-radius: 20px;
  border: 1px solid black;
  padding: 7px 0px;
  padding-left: 2vw;
  height: 5vh;
  margin-bottom: 1vh;
}

.categoryText {
  display: flex;
  justify-content: flex-start !important;
  font-size: 1rem;
  color: white;
  margin-top: 2vh !important;
  margin-bottom: 1vh;
}

.dark .categoryText {
  color: white;
}

.light .categoryText {
  color: black;
}

.customers {
  margin-top: 5vh;
  margin-bottom: 1vh;
  font-size: 1rem;
}

.dark .customers {
  color: white;
}

.light .customers {
  color: black;
}

.customerDivParticularCategory {
  border-radius: 5px;
  min-width: fit-content !important;
  height: 5vh !important;
  margin-right: 5%;
  align-items: center !important;
  text-align: center !important;
  font-size: 0.9rem;
  padding: 4px 5px 4px 5px !important;
  cursor: pointer;
}

.dark .customerDivParticularCategory {
  background-color: #353a50;
  color: white;
}

.light .customerDivParticularCategory {
  background-color: white;
  color: black;
}

.qrScanner {
  width: 60% !important;
  height: 25vh !important;
}

.paymentBox {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
}

.hrLine {
  margin-top: 4vh;
}

.paymentmethod {
  font-size: 0.9rem;
}

.holdOrderBtn {
  width: 45%;
  height: 5vh;
  background-color: #e79837 !important;
  border-radius: 20px;
  color: white;
  margin-top: 2vh;
  border: none;
  cursor: pointer;
  margin-right: 10%;
}

.CreditCardIcon {
  display: flex;
  justify-content: space-between;
}

.systemHealthText {
  font-size: 1rem;
  color: white;
  margin-bottom: 0px;
}

.particularElementName {
  text-transform: capitalize !important;
}

.systemHealthIcons {
  color: green !important;
  height: 10vh !important;
  width: 8% !important;
  margin-right: 10px;
}

.addCustomericonsDiv {
  font-size: 1rem;
  margin-bottom: 2vh;
  text-align: center;
}

.fixedPosition {
  margin-top: 10vh !important;
}

.adjustOrderBox {
  display: flex;
}

.adjustOrderBox p {
  padding: 2px;
  background-color: red;
  text-align: center;
  align-content: center !important;
  align-items: center !important;
}

.dark .systemHealthText {
  color: white;
}

.light .systemHealthText {
  color: black !important;
}

@media screen and (max-width: 900px) {

  /* .categoryText {
    display: none !important;
  } */
  /* .customerContainer {
    display: none !important;
  } */
  .fixedPosition {
    display: none;
  }
}

@media screen and (min-width: 900px) {
  .fixedPosition1 {
    display: none !important;
  }
}

.fixedPosition1 {
  margin-top: 5vh !important;
}

.systemHealthText1 {
  font-size: 1rem;
  margin-bottom: 0px;
}

.dark .systemHealthText1 {
  color: white;
}

.light .systemHealthText1 {
  color: black;
}

.systemHealthIcons1 {
  color: green !important;
  height: 5vh !important;
  width: 8% !important;
  margin-right: 10px;
}

.coupon-container-I {
  height: 65vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 1.3rem;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/Coupons.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,QAAQ;AACR;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kCAAkC;EAClC,uBAAuB;EACvB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;EACb,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE;;KAEG;EACH;;KAEG;EACH;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".couponDiv {\n  border-radius: 10px;\n  display: flex;\n  align-items: center !important;\n  text-align: center !important;\n  font-size: 0.9rem;\n  padding: 5px !important;\n  background-color: white;\n  border-style: outset;\n  padding: 0.5rem 0;\n}\n\n.dark .couponDiv {\n  background-color: #2b2f42 !important;\n  color: #fff !important;\n}\n\n.coupon-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n/* .button-class {\n  font-weight: bold;\n  float: right;\n  height: 2rem;\n  background-color: \"#5271FF\";\n  border-radius: 15px !important;\n} */\n\n.button-class {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background-color: none !important;\n}\n\n.button-class:focus {\n  outline: none;\n  background-color: #cddef9;\n  border: 1px solid #0562fb;\n}\n\n.button-class:hover {\n  background-color: \"#1f47ff\";\n}\n\n.button-selected {\n  color: red !important;\n}\n\n/* CSS */\n.button-class {\n  font-weight: bold;\n  color: #0562fb;\n  cursor: pointer;\n}\n\n.applied-text {\n  color: #0562fb !important;\n}\n\n.button-class:hover {\n  opacity: 1;\n  transform: scale(1.2);\n  transition: all 0.1s ease-in-out 0.1s;\n}\n\n.particularCategoryEachItemImg {\n  width: 60%;\n  display: flex;\n  justify-content: center !important;\n  margin: auto !important;\n  height: 13vh !important;\n  border-radius: 10px !important;\n  margin-top: 1vh !important;\n}\n\n.drawerCloseIcon {\n  cursor: pointer;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.drawerCloseIcon ::selection {\n  color: #7ed957;\n}\n\n.closePopCrossIcon {\n  color: white !important;\n}\n\n.popUpVerifyBtn {\n  margin-left: 8%;\n  font-size: medium;\n\n  border: none !important;\n  color: #7ed957;\n  cursor: pointer;\n}\n\n.popUpVerifyBtn1 {\n  margin-left: 8%;\n  font-size: medium;\n  color: white;\n  cursor: pointer;\n}\n\n.skipBtnContainer {\n  display: flex !important;\n  width: 100% !important;\n}\n\n.skipNowbtn {\n  cursor: pointer !important;\n}\n\n.coupons-container {\n  /* background-color: #f7f7ff; */\n  background-color: #F5F5F5;\n  padding: 1rem;\n  z-index: 1201;\n}\n\n@media (max-width: 576px) {\n  .coupons-container {\n    padding: 0.5rem;\n    z-index: 0;\n    margin-top: 3.2rem;\n  }\n}\n\n.dark .coupons-container {\n  background-color: #2b2f42;\n}\n\n.leftContainer {\n  padding-right: 5px;\n  width: 100% !important;\n}\n\n@media (max-width: 576px) {\n  .leftContainer {\n    padding: 0;\n  }\n}\n\n.addCustomericonsDiv {\n  display: flex;\n  align-content: center;\n  color: white;\n}\n\n.subContainer {\n  width: 100%;\n}\n\n.inputText {\n  width: 100%;\n  border-radius: 20px;\n  border: 1px solid black;\n  padding: 7px 0px;\n  padding-left: 2vw;\n  height: 5vh;\n  margin-bottom: 1vh;\n}\n\n.categoryText {\n  display: flex;\n  justify-content: flex-start !important;\n  font-size: 1rem;\n  color: white;\n  margin-top: 2vh !important;\n  margin-bottom: 1vh;\n}\n\n.dark .categoryText {\n  color: white;\n}\n\n.light .categoryText {\n  color: black;\n}\n\n.customers {\n  margin-top: 5vh;\n  margin-bottom: 1vh;\n  font-size: 1rem;\n}\n\n.dark .customers {\n  color: white;\n}\n\n.light .customers {\n  color: black;\n}\n\n.customerDivParticularCategory {\n  border-radius: 5px;\n  min-width: fit-content !important;\n  height: 5vh !important;\n  margin-right: 5%;\n  align-items: center !important;\n  text-align: center !important;\n  font-size: 0.9rem;\n  padding: 4px 5px 4px 5px !important;\n  cursor: pointer;\n}\n\n.dark .customerDivParticularCategory {\n  background-color: #353a50;\n  color: white;\n}\n\n.light .customerDivParticularCategory {\n  background-color: white;\n  color: black;\n}\n\n.qrScanner {\n  width: 60% !important;\n  height: 25vh !important;\n}\n\n.paymentBox {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.9rem;\n}\n\n.hrLine {\n  margin-top: 4vh;\n}\n\n.paymentmethod {\n  font-size: 0.9rem;\n}\n\n.holdOrderBtn {\n  width: 45%;\n  height: 5vh;\n  background-color: #e79837 !important;\n  border-radius: 20px;\n  color: white;\n  margin-top: 2vh;\n  border: none;\n  cursor: pointer;\n  margin-right: 10%;\n}\n\n.CreditCardIcon {\n  display: flex;\n  justify-content: space-between;\n}\n\n.systemHealthText {\n  font-size: 1rem;\n  color: white;\n  margin-bottom: 0px;\n}\n\n.particularElementName {\n  text-transform: capitalize !important;\n}\n\n.systemHealthIcons {\n  color: green !important;\n  height: 10vh !important;\n  width: 8% !important;\n  margin-right: 10px;\n}\n\n.addCustomericonsDiv {\n  font-size: 1rem;\n  margin-bottom: 2vh;\n  text-align: center;\n}\n\n.fixedPosition {\n  margin-top: 10vh !important;\n}\n\n.adjustOrderBox {\n  display: flex;\n}\n\n.adjustOrderBox p {\n  padding: 2px;\n  background-color: red;\n  text-align: center;\n  align-content: center !important;\n  align-items: center !important;\n}\n\n.dark .systemHealthText {\n  color: white;\n}\n\n.light .systemHealthText {\n  color: black !important;\n}\n\n@media screen and (max-width: 900px) {\n\n  /* .categoryText {\n    display: none !important;\n  } */\n  /* .customerContainer {\n    display: none !important;\n  } */\n  .fixedPosition {\n    display: none;\n  }\n}\n\n@media screen and (min-width: 900px) {\n  .fixedPosition1 {\n    display: none !important;\n  }\n}\n\n.fixedPosition1 {\n  margin-top: 5vh !important;\n}\n\n.systemHealthText1 {\n  font-size: 1rem;\n  margin-bottom: 0px;\n}\n\n.dark .systemHealthText1 {\n  color: white;\n}\n\n.light .systemHealthText1 {\n  color: black;\n}\n\n.systemHealthIcons1 {\n  color: green !important;\n  height: 5vh !important;\n  width: 8% !important;\n  margin-right: 10px;\n}\n\n.coupon-container-I {\n  height: 65vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 1.3rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
